import { IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonContent, IonHeader, IonIcon, IonPage, IonSpinner, IonTitle, IonToolbar } from '@ionic/react'
import Lightning from 'assets/icons/Lightning'
import { AuthContext } from 'contexts/AuthContext'
import useMerchantProfile from 'hooks/useMerchantProfile'
import { chevronBackOutline } from 'ionicons/icons'
import { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import client from 'utils/Api'
import './WelcomeToOshi.css'

const WelcomeToOshi = () => {
  const history = useHistory();
  const accountId = history.location.state?.opennode_account_id;
  const { authState } = useContext(AuthContext);
  const axiosClient = client(authState.token);
  const { data, loading } = useMerchantProfile(authState.user.uid, true);
  const [urlLoading, setUrlLoading] = useState(false)

  const [url, setUrl] = useState("");

  useEffect(() => {
    async function getUrl() {
      setUrlLoading(true)
      const res = await axiosClient.post('/account/managed/kyc', {
        opennode_account_id: accountId || data?.merchants[0]?.opennode_account_id
      });
      setUrl(res.data.url)
      setUrlLoading(false)
    }
    if (data?.merchants?.length) {
      getUrl();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <IonPage className={'welcome-oshi-root'}>
      <IonHeader className={'ion-no-border'}>
        <IonToolbar className={'background-color'}>
          <IonButtons slot="start">
            <IonButton
              fill="clear"
              onClick={() => history.goBack()}><IonIcon icon={chevronBackOutline} size="large" color="dark" /></IonButton>
          </IonButtons>
          <IonTitle>Business Verification</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonCard>
          <div className={"lightning-container inverted"}>
            <Lightning height={100} />
          </div>
          <IonCardHeader>
            <IonCardTitle>
              <h1>Your are ready to begin promoting!</h1>
            </IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            To enable withdrawals, or convert bitcoin to dollars, you'll need to complete the full business verification.
          </IonCardContent>
        </IonCard>
        <IonButton
          color={'primary'}
          expand={'block'}
          routerDirection="back"
          routerLink="/notifications">Finish later</IonButton>
        <IonButton
          disabled={!data?.merchants?.length || !url}
          color={'warning'}
          onClick={() => window.open(url)}
          expand={'block'}> {loading || urlLoading ? <IonSpinner name="crescent" /> : "Complete Business Verification"}</IonButton>
      </IonContent>
    </IonPage>
  )
}

export default WelcomeToOshi
